module.exports = __webpack_public_path__ + "img/logo-branca.4d4bb206.png";